const BackPage = () => (
  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.374541 8.04405L7.61252 0.396439C8.11279 -0.132146 8.92174 -0.132146 9.41669 0.396439L10.6195 1.66729C11.1197 2.19588 11.1197 3.05061 10.6195 3.57357L5.49435 9L10.6248 14.4208C11.1251 14.9494 11.1251 15.8041 10.6248 16.3271L9.42201 17.6036C8.92174 18.1321 8.11279 18.1321 7.61784 17.6036L0.379863 9.95595C-0.125731 9.42737 -0.125731 8.57263 0.374541 8.04405Z" fill="white"/>
  </svg>
);
export default BackPage